import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { TsoNumberSequence } from '../custom';

export class ConversionService {
    public static readonly CAPACITY_CATEGORY = {
        INTERRUPTIBLE: [
            'INTERRUPTIBLE',
            'INTERRUPTIBLE_LEVEL_1',
            'INTERRUPTIBLE_LEVEL_2',
            'INTERRUPTIBLE_LEVEL_N',
            'BACKHAUL_CAPACITY',
            'BACKHAUL_LEVEL_1',
            'BACKHAUL_LEVEL_2',
            'BACKHAUL_LEVEL_N',
            'U_BZK',
            'U_KC'
        ],
        FIRM: [
            'FZK',
            'BZK',
            'B_FZK',
            'B_FZK_1',
            'B_FZK_C',
            'DZK',
            'FIRM',
            'FZK_C',
            'FZK_INC',
            'FIRM_ADDITIONAL',
            'DZK_1',
            'DZK_2',
            'DZK_3',
            'DZK_4',
            'DZK_5',
            'DZK_SH',
            'IUKCF_1',
            'INCREMENTAL_OFFER_LEVEL_1',
            'INCREMENTAL_OFFER_LEVEL_2',
            'INCREMENTAL_OFFER_LEVEL_3',
            'INCREMENTAL_OFFER_LEVEL_4',
            'INCREMENTAL_OFFER_LEVEL_5'
        ]
    };

    constructor(private utilService: UtilService) {}

    public getTsosWhichSupportConversion(
        bundled,
        support0,
        support1
    ): TsoNumberSequence {
        if (!bundled) {
            if (!support0) {
                return [];
            }
            return ['0'];
        }

        let tsosWhichSupportConversion = [];

        if (support0) {
            tsosWhichSupportConversion.push('0');
        }

        if (support1) {
            tsosWhichSupportConversion.push('1');
        }

        return tsosWhichSupportConversion;
    }

    public isCapacityInterruptible(
        capacityCategory0,
        capacityCategory1
    ): boolean {
        if (angular.isUndefined(capacityCategory1)) {
            return (
                ConversionService.CAPACITY_CATEGORY.INTERRUPTIBLE.indexOf(
                    capacityCategory0
                ) !== -1
            );
        }
        return (
            ConversionService.CAPACITY_CATEGORY.INTERRUPTIBLE.indexOf(
                capacityCategory0
            ) !== -1 &&
            ConversionService.CAPACITY_CATEGORY.INTERRUPTIBLE.indexOf(
                capacityCategory1
            ) !== -1
        );
    }

    public isUpgradePossible(
        tsoConfig,
        capacityCategory0,
        capacityCategory1
    ): boolean {
        return (
            (tsoConfig.upgradeSupported0 || tsoConfig.upgradeSupported1) &&
            !this.isCapacityInterruptible(capacityCategory0, capacityCategory1)
        );
    }

    public isConversionPossible(tsoConfig, bundled: boolean) {
        return (
            (tsoConfig.conversionSupported0 ||
                tsoConfig.conversionSupported1) &&
            bundled
        );
    }

    public validateConversionAndUpgradeAreNotBothActiveForTheSameNetworkPoint(
        conversion0: ConversionDto,
        conversion1: ConversionDto,
        upgrade0: CapacityUpgradeDto,
        upgrade1: CapacityUpgradeDto
    ): boolean {
        const conversionActive0: boolean = !!(
            conversion0 &&
            conversion0.intervals &&
            conversion0.intervals[0] &&
            this.utilService.isValidDecimal(conversion0.intervals[0].amount)
        );
        const conversionActive1: boolean = !!(
            conversion1 &&
            conversion1.intervals &&
            conversion1.intervals[0] &&
            this.utilService.isValidDecimal(conversion1.intervals[0].amount)
        );

        const upgradeActive0: boolean = !!(
            upgrade0 && this.utilService.isValidDecimal(upgrade0.maxQuantity)
        );
        const upgradeActive1: boolean = !!(
            upgrade1 && this.utilService.isValidDecimal(upgrade1.maxQuantity)
        );

        return !(
            (conversionActive0 && upgradeActive0) ||
            (conversionActive1 && upgradeActive1)
        );
    }

    public findMaxQuantityOfConversions(
        conversions0: ConversionIntervalDto[] | null,
        conversions1: ConversionIntervalDto[] | null
    ): Decimal | null {
        if (conversions0 == null) conversions0 = [];
        if (conversions1 == null) conversions1 = [];
        const conversions = conversions0.concat(conversions1);

        return !conversions.length
            ? null
            : conversions
                  .filter(
                      (c) =>
                          c.amount != null &&
                          c.amount.originalValue != null &&
                          c.amount.originalValue.value != null
                  )
                  .map((c) => new Decimal(c.amount.originalValue.value))
                  .sort((a: Decimal, b: Decimal) =>
                      a.greaterThan(b) ? -1 : 1
                  )[0];
    }
}

angular.module('app').service('conversionService', ConversionService);
